import type { IPropertyFact } from 'src/services/api/properties/types';

export type IStringPropertyFact = IPropertyFact & { value: string };

export const isStringPropertyFact = (fact: IPropertyFact): fact is IStringPropertyFact =>
    typeof fact.value === 'string';
